import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { animateScroll as scroll } from 'react-scroll';
import ReactGA from 'react-ga';

class PageScroll extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }),
    pagePath: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  };

  componentDidMount() {
    window.setTimeout(() => this.checkPath(), 500);
  }

  shouldComponentUpdate() {
    this.viewable = this.isInViewport(this.el);
    return true;
  }

  componentDidUpdate(prevProps) {
    const { path } = this.props;
    if (path !== prevProps.path) {
      if (path.indexOf('work') !== -1) this.lastPos = window.pageYOffset;
      this.checkPath();
    }
  }

  lastPos = 0;
  viewable = false;

  sendPageView() {
    const {
      location: { pathname }
    } = this.props;
    ReactGA.set({ page: pathname });
    ReactGA.pageview(pathname);
  }

  checkPath = () => {
    const { pagePath, path } = this.props;
    this.lastPos = window.pageYOffset;
    if (path.indexOf(pagePath) !== -1 && path.length > 1) {
      this.sendPageView();
      scroll.scrollTo(this.el.offsetTop);
    }
  };

  getEl = el => {
    this.el = el;
  };

  isInViewport = element => {
    const rect = element.getBoundingClientRect();
    const html = document.documentElement;

    return rect.bottom <= (window.innerHeight || html.clientHeight) + element.offsetHeight / 2;
  };

  render() {
    return <div ref={this.getEl}>{this.props.children(this.lastPos, this.viewable)}</div>;
  }
}

export default PageScroll;



// WEBPACK FOOTER //
// ./src/components/PageScroll/index.js